import React from 'react';
import Highlighter from 'react-highlight-words';
import { useSelector } from 'react-redux';

import { Input, Spin } from 'antd';
import { Button, Typography } from 'antd';
import { find, isEmpty, map, some } from 'lodash';

import { LoadingOutlined } from '@ant-design/icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getSearchValue } from '@organisms/orders/orderProfile/common/redux/selectors';

import { SearchTab as SearchTabType, SelectedTabItem, toSelectedTabItem } from '../common/types';
import { CollapsibleArea } from './collapsibleArea';

interface Props {
    tab: SearchTabType;
    activeTab: string;
    onChange: (key: string) => void;
    selectedItems: SelectedTabItem[];
    onSelectItem: (item: SelectedTabItem, key: string) => void;
    showTabData?: boolean;
    onTabItemQuantityChange?: (item: SelectedTabItem, key: string, value: string) => void;
    /** Результаты свёрнуты кнопкой под вкладками — заголовок вкладки остаётся */
    collapsed?: boolean;
}
const circleIcon = <LoadingOutlined style={{ fontSize: 32, color: 'orange' }} spin />;

export const SearchTab: React.FC<Props> = ({
    tab,
    activeTab,
    onChange,
    onSelectItem,
    selectedItems,
    showTabData,
    onTabItemQuantityChange,
    collapsed = false,
}) => {
    const searchValue = useSelector(getSearchValue);

    return (
        <div className="search-tab">
            <div
                className="search-tab-header"
                style={{ borderBottom: activeTab === tab.key ? 'none' : '' }}
            >
                <div
                    onClick={() => {
                        !tab.preventDefault && onChange(tab.key);
                        tab.onClick && tab.onClick(tab.key);
                    }}
                >
                    {tab.icon && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <FontAwesomeIcon icon={tab.icon} color="orange" />
                            {tab.label && <Typography.Text>{tab.label}</Typography.Text>}
                        </div>
                    )}
                </div>
            </div>
            {tab.isLoading && (
                <div className="search-tab-loading">
                    <Spin indicator={circleIcon} />
                </div>
            )}
            {!isEmpty(tab.data) && !activeTab && (searchValue || showTabData) && (
                <CollapsibleArea isOpen={!collapsed}>
                    {map(tab.data, ({ data: item, type }) => {
                        return (
                            <div
                                key={item.id}
                                onClick={() => {
                                    onSelectItem(toSelectedTabItem(item, type), tab.key);
                                }}
                                className="search-tab-content"
                                style={{
                                    background: some(selectedItems, { id: item.id })
                                        ? '#D0E0C5'
                                        : 'white',
                                }}
                            >
                                <Highlighter
                                    searchWords={searchValue?.split(' ') || []}
                                    autoEscape={true}
                                    textToHighlight={item.name}
                                />

                                {some(selectedItems, { id: item.id }) && (
                                    <div className="check-icon">
                                        <FontAwesomeIcon icon={faCheck} color="green" size="4x" />
                                    </div>
                                )}
                                {some(selectedItems, { id: item.id }) &&
                                    onTabItemQuantityChange && (
                                        <div
                                            style={{
                                                width: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                position: 'absolute',
                                                bottom: 0,
                                                left: 0,
                                            }}
                                        >
                                            <Button
                                                style={{ padding: '0 5px' }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (
                                                        +find(selectedItems, { id: item.id })
                                                            ?.quantity -
                                                            1 <
                                                        1
                                                    )
                                                        return;
                                                    onTabItemQuantityChange(
                                                        item,
                                                        type,
                                                        (
                                                            +find(selectedItems, { id: item.id })
                                                                ?.quantity - 1
                                                        ).toString()
                                                    );
                                                }}
                                            >
                                                -
                                            </Button>
                                            <Input
                                                style={{ padding: '5px 0', textAlign: 'center' }}
                                                className="quantity-input"
                                                type="number"
                                                onFocus={(e) => e.target.select()}
                                                min={1}
                                                onClick={(e) => e.stopPropagation()}
                                                value={
                                                    find(selectedItems, { id: item.id })?.quantity
                                                }
                                                onChange={(e) =>
                                                    onTabItemQuantityChange(
                                                        item,
                                                        type,
                                                        e.target.value
                                                    )
                                                }
                                            />
                                            <Button
                                                style={{ padding: '0 5px' }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onTabItemQuantityChange(
                                                        item,
                                                        type,
                                                        (
                                                            +find(selectedItems, { id: item.id })
                                                                ?.quantity + 1
                                                        ).toString()
                                                    );
                                                }}
                                            >
                                                +
                                            </Button>
                                        </div>
                                    )}
                            </div>
                        );
                    })}
                </CollapsibleArea>
            )}
        </div>
    );
};
